export function coupleDisplayName(row: {
  hisFirstName?: string;
  hisLastName?: string;
  herFirstName?: string;
}) {
  const last = row.hisLastName || "";
  const his = row.hisFirstName || "";
  const her = row.herFirstName || "";
  if (!last && !his && !her) return "Untitled couple";
  return `${last}${last && his ? ", " : ""}${his}${her ? ` and ${her}` : ""}`.trim();
}

export function isInactiveCoupleStatus(status?: string) {
  return (
    status === "DECEASED" || status === "DIVORCED" || status === "INACTIVE"
  );
}

export function canToggleAdminRights(row: {
  hisEmail?: string;
  herEmail?: string;
}) {
  return (
    row.hisEmail !== "tkolkebeck@me.com" &&
    row.herEmail !== "tkolkebeck@satx.rr.com" &&
    row.hisEmail !== "jimmieflores@gmail.com" &&
    row.herEmail !== "dulceaflores@gmail.com"
  );
}
